import * as apiFactory from "./ApiFactory";
import { Metadata } from "@/models/Metadata";
import { Api } from "./Api";

import type ExtendedMetadata from "@/models/ExtendedMetadata";

export async function getAll(clientName: string, brand: string, caseReference: string): Promise<Metadata[]> {
  const client = await apiFactory.WithBearer();
  return await client.get<Metadata[]>(["api/metadata", clientName, brand, caseReference, "file list"]);
}
export async function refresh(clientName: string, brand: string, caseReference: string): Promise<Metadata[]> {
  const client = await apiFactory.WithBearer();
  return await client.getWithPollingSignal<Metadata[]>([
    "api/metadata/refresh",
    clientName,
    brand,
    caseReference,
    "file list",
  ]);
}
export async function get(
  clientName: string,
  brand: string,
  caseReference: string,
  fileReference: string,
): Promise<Metadata> {
  const client = await apiFactory.WithBearer();
  return await client.get<Metadata>(["api/metadata", clientName, brand, caseReference, fileReference, "file list"]);
}
export async function getExtendedMetadata(
  clientName: string,
  brand: string,
  caseReference: string,
  fileReference: string,
): Promise<ExtendedMetadata> {
  const client: Api = await apiFactory.WithBearer();
  return await client.get<ExtendedMetadata>([
    "api/metadata",
    clientName,
    brand,
    caseReference,
    fileReference,
    "Extended Metadata",
  ]);
}
export async function saveProperty(
  clientName: string,
  brand: string,
  caseReference: string,
  fileReference: string,
  property: string,
  metadata: object,
): Promise<void> {
  const client = await apiFactory.WithBearer();
  await client.post<object, void>(
    ["api/metadata", clientName, brand, caseReference, fileReference, property],
    metadata,
  );
}

export async function saveClassification(
  clientName: string,
  brand: string,
  caseReference: string,
  fileReference: string,
  metadata: object,
): Promise<void> {
  const client = await apiFactory.WithBearer();
  await client.post<object, void>(
    ["api/fileEntryClassification", clientName, brand, caseReference, fileReference],
    metadata,
  );
}

export async function deleteProperty(
  clientName: string,
  brand: string,
  caseReference: string,
  fileReference: string,
  property: string,
): Promise<void> {
  const client = await apiFactory.WithBearer();
  await client.delete(["api/metadata", clientName, brand, caseReference, fileReference, property]);
}
export async function save(clientName: string, brand: string, caseReference: string, metadata: object) {
  const client = await apiFactory.WithBearer();
  return await client.post(["api/metadata", clientName, brand, caseReference], metadata);
}
